/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/video-analysis-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/video-analysis-api-client";
import type { StationSettingsClientControllerPatchSettingsMutationRequest, StationSettingsClientControllerPatchSettingsMutationResponse, StationSettingsClientControllerPatchSettingsPathParams } from "../models/StationSettingsClientControllerPatchSettings";

function getStationSettingsClientControllerPatchSettingsUrl(entityId: StationSettingsClientControllerPatchSettingsPathParams["entityId"]) {
  const res = { method: 'PATCH', url: `/station-settings/${entityId}` as const }  
  return res
}

/**
 * @description Update settings for a specific station (client access)
 * @summary Patch station settings
 * {@link /station-settings/:entityId}
 */
export async function stationSettingsClientControllerPatchSettings(entityId: StationSettingsClientControllerPatchSettingsPathParams["entityId"], data?: StationSettingsClientControllerPatchSettingsMutationRequest, config: Partial<RequestConfig<StationSettingsClientControllerPatchSettingsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<StationSettingsClientControllerPatchSettingsMutationResponse, ResponseErrorConfig<Error>, StationSettingsClientControllerPatchSettingsMutationRequest>({ method : "PATCH", url : getStationSettingsClientControllerPatchSettingsUrl(entityId).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}